<template>
    <div class="container-md container-app p-0 ">
        <div class="login">
            <h1 class="title-nobkg text-center"><b>{{$t('account.accedi_dati')}}</b></h1>
            <div class="content">
                <form>
                    <div class="form-group">
                        <input type="text" class="form-control"
                               :placeholder="$t('account.nome_utente')+' *'"
                               v-model="form.account">
                    </div>
                    <div class="form-group">
                        <input type="password" class="form-control"
                               :placeholder="$t('password').capitalize()+' *'"
                               v-model="form.password"
                               autocomplete>
                    </div>
                    <router-link :to="{name:'user.password.remember'}" class="a-nobkg">
                        <i>{{$t('account.password.dimenticata')}}?</i>
                    </router-link>
                    <br><br>
                    <div class="text-center">
                        <button type="submit" class="btn btn-primary"
                                style="min-width:230px;"
                                @click.prevent="handleLogin(form)"
                                :disabled="this.loading_visible">
                            {{$t(('account.accedi'))}}
                        </button>
                    </div>
                    <br>
                  <div class="row">
                    <div class="col-sm-12 d-flex flex-column align-items-center justify-content-center mb-3 mb-sm-0">
                      <button v-if="mobileAppGoogleEnabled"
                              type="button"
                              class="btn btn-light bg-button-google"
                              style="width:260px; height:40px;"
                              @click.prevent="handleMobileGoogleSignIn"
                              :disabled="this.loading_visible">
                        <img
                            src="/img/be/google-g.png"
                            alt=""
                            aria-hidden="true"
                            style="width:25px; max-height:25px; margin-right: 10px;"
                        >
                        {{$t('continua_con_google')}}
                      </button>
                      <button v-if="mobileAppAppleEnabled"
                              type="button"
                              class="btn bg-button-apple text-white"
                              style="width:260px; height:40px; padding-top: 2px;"
                              :class="{'mt-3': mobileAppGoogleEnabled}"
                              @click.prevent="handleMobileAppleSignIn"
                              :disabled="this.loading_visible">
                        <img
                            src="/img/be/svg/apple-logo-white.svg"
                            alt=""
                            aria-hidden="true"
                            style="width:30px; height:35px; margin-right: 10px;"
                        >
                       <span style="margin-right: 10px;"> {{$t('continua_con_apple')}}</span>
                      </button>
                      <div v-if="!mobileAppHasNativeAuth" ref="googleButtonWrapper" aria-label="Google Sign-In"></div>
                    </div>
                    </div>
                </form>
            </div>
        </div>
        <br>
        <div class="text-center">
            <router-link :to="{name:'user.registration'}">
                <button type="button" class="btn btn-trasp" style="min-width:230px;">
                    {{$t('account.no_registrato')}}?
                </button>
            </router-link>
        </div>
        <br>
        <div class="text-center" v-if="this.order_type === 'ORDINA_TAVOLO'">
            <button type="button" class="btn btn-trasp" style="min-width:230px;" @click="this.onContinueAsGuest">
                {{$t('account.prosegui_ospite')}}
            </button>
        </div>
        <br>
        <br>
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex';
import {login} from '../../api/account';

import ModalErrors from '../partials/ModalErrors';

let googleIdentityScriptPromise = null;

function decodeGoogleJwtPayload(idToken) {
    const tokenParts = idToken.split('.');
    if (tokenParts.length < 2) {
        return {};
    }

    const base64 = tokenParts[1].replace(/-/g, '+').replace(/_/g, '/');
    const paddedBase64 = base64 + '='.repeat((4 - base64.length % 4) % 4);

    try {
        const decoded = window.atob(paddedBase64);
        return JSON.parse(decoded);
    } catch (e) {
        return {};
    }
}

export default {
    name: "Login",
    components: {ModalErrors},
    data: function () {
        return {
            form: {
                account: '',
                password: ''
            },
            googleProfile: {},
            appleProfile: {},
            pendingAppleAuthPayload: null,
            mobileAppGoogleEnabled: false,
            mobileAppAppleEnabled: false,
            mobileMessageHandler: null
        }
    },
    mounted() {
        this.mobileAppGoogleEnabled = !!(window.kuokkoMobileAppAuthProviders && window.kuokkoMobileAppAuthProviders.google);
        this.mobileAppAppleEnabled = !!(window.kuokkoMobileAppAuthProviders && window.kuokkoMobileAppAuthProviders.apple);
        this.setupMobileAuthHandlers();
        this.initializeGoogleSignIn();
    },
    beforeDestroy() {
        this.teardownMobileAuthHandlers();
    },
    computed: {
        mobileAppHasNativeAuth: function () {
            return this.mobileAppGoogleEnabled || this.mobileAppAppleEnabled;
        },
        ...mapState('global', {
            loading_visible: state => state.loading_visible
        }),
        ...mapState('localization', {
            language: state => state.language
        }),
        ...mapState('restaurant', {
            id_ristorante: state => state.id,
            locale: state => state.locale
        }),
        ...mapState('order', {
            order_type: state => state.type
        })
    },
    methods: {
        handleLogin: function (params, post_callback = null, error_callback = null) {
            this.showLoading(true);

            login(this.language, Object.assign({}, {
                id_ristorante: this.id_ristorante,
                id_locale: this.locale.id
            }, params)).then((response) => {
                this.postLogin(response);
            }).catch(({messages, data, fromEndpoint}) => {
                if (fromEndpoint && error_callback) {
                    error_callback(data);
                } else if (messages) {
                    this.showModalErrors({
                        title: 'ACCOUNT',
                        errors: messages
                    });
                }
            }).finally(() => {
                if (post_callback) {
                    post_callback();
                }
                this.showLoading(false);
            })
        },
        postLogin: function (response) {
            this.pendingAppleAuthPayload = null;
            this.saveUserData({
                api_key: response.api_key,
                language: response.cod_lingua,
                email: response.account
            });

            if (this.language !== response.cod_lingua) {
                this.setLanguage(response.cod_lingua);
            }

            switch (this.$route.query.back) {
                case 'cart':
                    this.$router.replace({name: 'cart'});
                    break;
                default:
                    this.$router.replace({name: 'home'});
                    break;
            }
        },
        initializeGoogleSignIn: function () {
            if (this.mobileAppHasNativeAuth) {
                return;
            }

            if (!process.env.MIX_GOOGLE_CLIENT_ID || !this.$refs.googleButtonWrapper) {
                return;
            }

            this.loadGoogleIdentityScript().then(() => {
                window.google.accounts.id.initialize({
                    client_id: process.env.MIX_GOOGLE_CLIENT_ID,
                    callback: (credentialResponse) => this.handleGoogleCredentialResponse(credentialResponse)
                });

                window.google.accounts.id.renderButton(this.$refs.googleButtonWrapper, {
                    theme: "outline",
                    size: "large",
                    text: "continue_with",
                    shape: "rectangular",
                    width: 230
                });
            }).catch(() => {
                alert("Google error");
            });
        },
        loadGoogleIdentityScript: function () {
            if (window.google && window.google.accounts && window.google.accounts.id) {
                return Promise.resolve();
            }

            if (googleIdentityScriptPromise) {
                return googleIdentityScriptPromise;
            }

            googleIdentityScriptPromise = new Promise((resolve, reject) => {
                const existingScript = document.getElementById('google-identity-services');
                if (existingScript) {
                    existingScript.addEventListener('load', resolve, {once: true});
                    existingScript.addEventListener('error', reject, {once: true});
                    return;
                }

                const script = document.createElement('script');
                script.id = 'google-identity-services';
                script.src = 'https://accounts.google.com/gsi/client';
                script.async = true;
                script.defer = true;
                script.onload = resolve;
                script.onerror = reject;
                document.head.appendChild(script);
            });

            return googleIdentityScriptPromise;
        },
        setupMobileAuthHandlers: function () {
            if (!this.mobileAppHasNativeAuth) {
                return;
            }

            this.mobileMessageHandler = async (event) => {
                let data = event.data;

                try {
                    data = JSON.parse(data);
                } catch (e) {
                    return;
                }

                if (data.type === 'GOOGLE_SIGN_IN_SUCCESS') {
                    await this.handleMobileGoogleSignInSuccess(data.payload);
                } else if (data.type === 'GOOGLE_SIGN_IN_ERROR') {
                    this.handleMobileGoogleSignInError(data.payload);
                } else if (data.type === 'APPLE_SIGN_IN_SUCCESS') {
                    await this.handleMobileAppleSignInSuccess(data.payload);
                } else if (data.type === 'APPLE_SIGN_IN_ERROR') {
                    this.handleMobileAppleSignInError(data.payload);
                }
            };

            window.addEventListener('message', this.mobileMessageHandler);
        },
        teardownMobileAuthHandlers: function () {
            if (this.mobileMessageHandler) {
                window.removeEventListener('message', this.mobileMessageHandler);
                this.mobileMessageHandler = null;
            }
        },
        handleMobileGoogleSignIn: function () {
            if (!window.ReactNativeWebView) {
                alert("Google error");
                return;
            }

            this.showLoading(true);
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'GOOGLE_SIGN_IN'
            }));
        },
        handleMobileAppleSignIn: function () {
            if (!window.ReactNativeWebView) {
                alert("Apple login error");
                return;
            }

            this.showLoading(true);
            window.ReactNativeWebView.postMessage(JSON.stringify({
                type: 'APPLE_SIGN_IN'
            }));
        },
        handleMobileGoogleSignInSuccess: async function (payload) {
            const loginParams = {};

            this.googleProfile = this.extractGoogleProfileFromMobilePayload(payload);

            if (payload && payload.idToken) {
                loginParams.google_id_token = payload.idToken;
            }

            if (payload && payload.accessToken) {
                loginParams.google_access_token = payload.accessToken;
            }

            if (!loginParams.google_id_token && !loginParams.google_access_token) {
                this.showLoading(false);
                alert("Google error");
                return;
            }

            this.handleLogin(loginParams, null, this.handleGoogleLoginError);
        },
        handleMobileAppleSignInSuccess: async function (payload) {
            if (!payload || !payload.identityToken || !payload.user) {
                this.showLoading(false);
                alert("Apple login error");
                return;
            }

            this.appleProfile = this.extractAppleProfileFromMobilePayload(payload);
            this.pendingAppleAuthPayload = {
                identityToken: payload.identityToken,
                user: payload.user,
                info: {
                    nome: this.appleProfile.nome,
                    cognome: this.appleProfile.cognome
                }
            };

            this.handleLogin({
                apple_identity_token: payload.identityToken,
                apple_client_user: payload.user,
                info: {
                    nome: this.appleProfile.nome,
                    cognome: this.appleProfile.cognome
                }
            }, null, this.handleAppleLoginError);
        },
        handleMobileGoogleSignInError: function (payload) {
            this.showLoading(false);

            if (!payload || payload.code === 'CANCELED') {
                return;
            }

            alert(payload.message || "Google error");
        },
        handleMobileAppleSignInError: function (payload) {
            this.showLoading(false);
            this.pendingAppleAuthPayload = null;

            if (!payload || payload.code === 'CANCELED') {
                return;
            }

            alert(payload.message || "Apple login error");
        },
        extractGoogleProfileFromMobilePayload: function (payload) {
            const tokenProfile = payload && payload.idToken ? decodeGoogleJwtPayload(payload.idToken) : {};
            const userProfile = payload && payload.user ? payload.user : {};

            return Object.assign({}, tokenProfile, {
                email: userProfile.email || tokenProfile.email || '',
                given_name: userProfile.givenName || tokenProfile.given_name || '',
                family_name: userProfile.familyName || tokenProfile.family_name || ''
            });
        },
        extractAppleProfileFromMobilePayload: function (payload) {
            const fullName = payload && payload.fullName ? payload.fullName : {};

            return {
                email: payload && payload.email ? payload.email : '',
                nome: fullName.givenName || '',
                cognome: fullName.familyName || '',
                apple_identity_sub: payload && payload.user ? payload.user : ''
            };
        },
        handleGoogleCredentialResponse: function (credentialResponse) {
            if (!credentialResponse || !credentialResponse.credential) {
                alert("Google error");
                return;
            }

            this.googleProfile = decodeGoogleJwtPayload(credentialResponse.credential);

            this.handleLogin({
                google_id_token: credentialResponse.credential,
            }, null, this.handleGoogleLoginError);
        },
        handleGoogleLoginError: function (data) {
            if (data.status === 'KUOKKO_EMAIL_NOT_FOUND') {
                this.$router.replace({
                    name: 'user.registration',
                    query: {
                        email: this.googleProfile.email || '',
                        nome: this.googleProfile.given_name || '',
                        cognome: this.googleProfile.family_name || ''
                    }
                });
            } else if (data.status === "GOOGLE_ERROR") {
                alert("Google error");
            }
        },
        handleAppleLoginError: function (data) {
            if (data.status === 'KUOKKO_EMAIL_NOT_FOUND') {
                const userInfo = data.user_info || {};

                this.$router.replace({
                    name: 'user.registration',
                    params: {
                        appleAuth: this.pendingAppleAuthPayload
                    },
                    query: {
                        email: userInfo.email || this.appleProfile.email || '',
                        nome: userInfo.nome || this.appleProfile.nome || '',
                        cognome: userInfo.cognome || this.appleProfile.cognome || '',
                        from: 'APPLE',
                        apple_identity_sub: userInfo.apple_identity_sub || this.appleProfile.apple_identity_sub || ''
                    }
                });
            } else {
                this.pendingAppleAuthPayload = null;
                alert("Apple login error");
            }
        },
        onContinueAsGuest: function () {
            this.$router.replace({name: 'cart.summary', query: {guest: '1'}});
        },
        ...mapActions('global', [
            'showLoading',
            'showModalErrors'
        ]),
        ...mapActions('localization', [
            'setLanguage'
        ]),
        ...mapActions('auth', [
            'saveUserData'
        ]),
    }
}
</script>
